import {
    RegistrationFlow,
    RegistrationFlowStep,
} from '@rhg/hooks/use-registration-context/types';
import { useRegistrationDialog } from '@rhg/hooks/use-registration-dialog';
import { useUserBlocker } from '@rhg/hooks/use-user-blocker';
import { UserBlocker } from '@rhg/hooks/use-user-blocker/types';
import programMessages from '@rhg/lang/messages/program';
import { logger } from '@rhg/libs/logger';
import { Box, Button, SxProps, Theme } from '@rhg/libs/material';
import { LockThinOutline } from '@rhg/libs/material/icons';
import { styleIconLarge } from '@rhg/libs/material/sx';
import { useIntl } from 'react-intl';
import { Banner } from '../banner';

const styleIconContainer = {
    backgroundColor: 'info.dark',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};
const styleIcon = { ...styleIconLarge, color: 'white' };

interface AccessCodeBannerProps {
    sx?: SxProps<Theme>;
}

const AccessCodeBannerShowing = ({ sx }: AccessCodeBannerProps) => {
    const { formatMessage } = useIntl();
    const { showRegistrationDialog } = useRegistrationDialog();

    const actionProps = {
        color: 'inherit' as const,
        component: Button,
    };

    const onClickAction = () => {
        showRegistrationDialog({
            currentStep: RegistrationFlowStep.AccessCode,
            registrationFlow: RegistrationFlow.ExistingRegistration,
        }).catch((err) =>
            logger.error('Failed to show registration dialog', {}, err as Error)
        );
    };

    return (
        <>
            <Banner
                sx={{
                    backgroundColor: 'info.main',
                    color: 'info.contrastText',
                    ...sx,
                }}
                primaryAction={{
                    trackAction: 'GoToAccessCode',
                    actionText: formatMessage(
                        programMessages['program.enter_access_code']
                    ),
                    actionProps,
                    onClickAction,
                }}
                title={formatMessage(
                    programMessages['program.enter_your_access_code']
                )}
                titleColor="info.contrastText"
                subtitle={formatMessage(
                    programMessages['program.validate_your_eligibility']
                )}
                subtitleColor="info.contrastText"
                leftImage={
                    <Box sx={styleIconContainer}>
                        <LockThinOutline sx={styleIcon} color="info" />
                    </Box>
                }
            />
        </>
    );
};

export function AccessCodeBanner({ sx }: { sx?: SxProps<Theme> }) {
    const { userBlocker } = useUserBlocker();

    if (userBlocker === UserBlocker.Unsponsored) {
        return <AccessCodeBannerShowing sx={sx} />;
    }
}
